// @ts-nocheck
import React, { ReactNode } from 'react';
import moment from 'moment';
import capitalize from 'capitalize';
import Color from 'color';
import {
    useMediaQuery,
    Theme,
    Card as MuiCard,
    CardContent,
    withStyles,
    Chip,
} from '@material-ui/core';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import {
    AutocompleteInput,
    DateField,
    downloadCSV,
    DateInput,
    ShowButton,
    Filter,
    ReferenceInput,
    SelectInput,
    TextField,
    TextInput,
    ChipField,
    ReferenceField,
    SimpleList,
    FilterList,
    FilterListItem,
} from 'react-admin';
import CustomizableGrid from '../components/CustomizableGrid';
import { ColumnConfig } from '../hooks/useColumnReorder';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-admin';
import CustomSearchInput from '../components/CustomSearchInput';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import LocalOfferIcon from '@material-ui/icons/LocalOfferOutlined';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOnOutlined';
import UserReferenceField from '../components/UserReferenceField';
import BoxitChipField from '../components/BoxitChipField';
import TimeSlotField from '../components/TimeSlotField';
import VolumeField from '../components/VolumeField';
import BoxitPagination from '../components/BoxitPagination';
import RequestPagination from './RequestPagination';
import { RequestStatus, RequestType } from '../constants';
import CityField from '../components/CityField';
import { getRequestColor } from './utils';
import { SelectArrayInput } from 'react-admin';
import { FunctionField } from 'react-admin';
import humanize from '../util/humanize';
import storageIcon from './icons/storage.png';
import otherIcon from './icons/services.png';
import OrderReferenceField from '../components/OrderReferenceField';
import AddressReferenceField from '../components/AddressReferenceField';
import RequestUserField from './components/RequestUserField';

const useStyles = makeStyles({
    root: {
        padding: '1px 8px',
        color: '#595959',
        background: '#F5F5F5',
        borderRadius: '4px',
    },
});

const rowStyle = record => {
    if (record.status === RequestStatus.complete) {
        return {};
    }

    const reqColor = getRequestColor(record);

    return {
        backgroundColor: Color(reqColor).alpha(0.1),
    };
};

const Card = withStyles(theme => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            order: 1, // display on the left rather than on the right of the list
            width: '12em',
            marginLeft: '1em',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
}))(MuiCard);

const exporter = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, 'addressId', 'addresses').then(addresses => {
        fetchRelatedRecords(records, 'teamId', 'teams').then(teams => {
            fetchRelatedRecords(records, 'partnerId', 'partners').then(
                partners => {
                    fetchRelatedRecords(records, 'cityId', 'city').then(
                        cities => {
                            fetchRelatedRecords(
                                records,
                                'warehouseId',
                                'warehouses'
                            ).then(warehouses => {
                                fetchRelatedRecords(
                                    records,
                                    'assigneeId',
                                    'users'
                                ).then(assignees => {
                                    const data = records.map(record => ({
                                        ...record,
                                        AddressLine:
                                            addresses[record.addressId] &&
                                            addresses[record.addressId].line1,
                                        AddressArea:
                                            addresses[record.addressId] &&
                                            addresses[record.addressId].area,
                                        City:
                                            cities[record.cityId] &&
                                            cities[record.cityId].name,
                                        Name: record.user.name,
                                        Partner:
                                            partners[record.partnerId] &&
                                            partners[record.partnerId].name,
                                        Sales:
                                            assignees[record.assigneeId] &&
                                            assignees[record.assigneeId].name,
                                        Phone: record.user.phone,
                                        Type: record.type,
                                        address: record.addressId,
                                        Team:
                                            teams[record.teamId] &&
                                            teams[record.teamId].name,
                                        Warehouse:
                                            warehouses[record.warehouseId] &&
                                            warehouses[record.warehouseId].name,
                                        Time: `${record.from} to ${record.to}`,
                                        Date: record.date,
                                        CBM: record.size,
                                        Rating: record.rating,
                                        Feedback: record.feedback,
                                    }));

                                    const csv = convertToCSV({
                                        data,
                                        fields: [
                                            'City',
                                            'Date',
                                            'Time',
                                            'Partner',
                                            'Sales',
                                            'Name',
                                            'Phone',
                                            'CBM',
                                            'Type',
                                            'AddressLine',
                                            'AddressArea',
                                            'Warehouse',
                                            'Team',
                                            'Vehicle',
                                            'Rating',
                                            'Feedback',
                                        ],
                                    });
                                    downloadCSV(csv, `Request_${Date.now()}`);
                                });
                            });
                        }
                    );
                }
            );
        });
    });
};

const DateFilter = () => (
    <FilterList label="pos.filter.date" icon={<AccessTimeIcon />}>
        <FilterListItem
            label="Today"
            value={{
                date: moment().format('YYYY-MM-DD'),
            }}
        />
        <FilterListItem
            label="Tomorrow"
            value={{
                date: moment().add(1, 'days').format('YYYY-MM-DD'),
            }}
        />
        <FilterListItem
            label="This Week"
            value={{
                'date[$gte]': moment().startOf('week').format('YYYY-MM-DD'),
                'date[$lte]': moment().endOf('week').format('YYYY-MM-DD'),
            }}
        />
        <FilterListItem
            label="Last Week"
            value={{
                'date[$gte]': moment()
                    .subtract(1, 'weeks')
                    .startOf('week')
                    .format('YYYY-MM-DD'),
                'date[$lte]': moment()
                    .subtract(1, 'weeks')
                    .endOf('week')
                    .format('YYYY-MM-DD'),
            }}
        />
        <FilterListItem
            label="This Month"
            value={{
                'date[$gte]': moment().startOf('month').format('YYYY-MM-DD'),
                'date[$lte]': moment().endOf('month').format('YYYY-MM-DD'),
            }}
        />
        <FilterListItem
            label="Last Month"
            value={{
                'date[$gte]': moment()
                    .subtract(1, 'month')
                    .startOf('month')
                    .format('YYYY-MM-DD'),
                'date[$lte]': moment()
                    .subtract(1, 'month')
                    .endOf('month')
                    .format('YYYY-MM-DD'),
            }}
        />
        <FilterListItem
            label="This Year"
            value={{
                'date[$gte]': moment().startOf('year').format('YYYY-MM-DD'),
                'date[$lte]': moment().endOf('year').format('YYYY-MM-DD'),
            }}
        />
    </FilterList>
);

const TypeFilter = () => (
    <FilterList label="pos.filter.type" icon={<LocalOfferIcon />}>
        {Object.values(RequestType).map(i => (
            <FilterListItem
                label={humanize(i)}
                value={{
                    type: i,
                }}
            />
        ))}
    </FilterList>
);

const StatusFilter = () => (
    <FilterList label="pos.filter.status" icon={<MonetizationOnIcon />}>
        {Object.values(RequestStatus).map(i => (
            <FilterListItem
                label={capitalize(i)}
                value={{
                    status: i,
                }}
            />
        ))}
    </FilterList>
);

const FilterSidebar = () => (
    <Card>
        <CardContent>
            <DateFilter />
            <TypeFilter />
            <StatusFilter />
        </CardContent>
    </Card>
);

const RequestFilter = props => (
    <Filter variant="standard" {...props}>
        <CustomSearchInput alwaysOn />

        <ReferenceInput
            source="partnerId"
            reference="partners"
            resource="partners"
            label="Partner"
        >
            <SelectInput />
        </ReferenceInput>

        <SelectInput
            style={{ minWidth: '10rem' }}
            source="status"
            choices={Object.keys(RequestStatus).map(c => ({
                id: c,
                name: c,
            }))}
        />

        <SelectInput
            source="type"
            choices={Object.keys(RequestType).map(c => ({
                id: c,
                name: humanize(c),
            }))}
        />

        <SelectInput
            label="Charges status"
            source="chargeTypes"
            choices={[
                { id: 'filterChargesWithAnd', name: 'filterChargesWithAnd' },
                { id: 'filterChargesWithOr', name: 'filterChargesWithOr' },
                { id: 'filterChargesEmpty', name: 'filterChargesEmpty' },
            ]}
        />

        <ReferenceInput
            source="userId"
            reference="users"
            resource="users"
            label="Customer"
        >
            <AutocompleteInput
                shouldRenderSuggestions={val => val.trim().length > 2}
                optionText={user => (user.name ? user.name : user.email)}
            />
        </ReferenceInput>

        <ReferenceInput
            source="countryId"
            reference="country"
            resource="country"
            label="Country"
        >
            <SelectInput />
        </ReferenceInput>

        <ReferenceInput
            source="cityId"
            reference="city"
            resource="city"
            label="City"
        >
            <SelectInput />
        </ReferenceInput>

        <ReferenceInput
            source="teamId"
            reference="teams"
            resource="teams"
            label="Team"
        >
            <AutocompleteInput
                shouldRenderSuggestions={val => val.trim().length > 2}
                optionText={choice => `${choice.name}`}
            />
        </ReferenceInput>

        <DateInput
            source="date[$gte]"
            label="Date From"
            parse={v => v && moment(v).format('YYYY-MM-DD')}
        />
        <DateInput
            source="date[$lte]"
            label="Date To"
            parse={v => v && moment(v).format('YYYY-MM-DD')}
        />
    </Filter>
);

// Custom field components with links
const CityNameField = ({ record }) => {
    if (!record) return null;
    // Handle both nested city object and direct cityName property
    const cityName = record.city?.name || record.cityName;
    if (!cityName) return null;
    return <span>{cityName}</span>;
};

const UserNameField = ({ record }) => {
    if (!record) return null;
    // Handle both nested user object and direct userName property
    const userName = record.user?.name || record.userName;
    if (!userName) return null;
    return <Link to={`/users/${record.userId}/show`}>{userName}</Link>;
};

const AssigneeNameField = ({ record }) => {
    if (!record) return null;
    // Handle both nested assignee object and direct assigneeName property
    const assigneeName = record.assignee?.name || record.assigneeName;
    if (!assigneeName) return null;
    return <Link to={`/users/${record.assigneeId}/show`}>{assigneeName}</Link>;
};

const TeamNameField = ({ record }) => {
    if (!record) return null;
    // Handle both nested team object and direct teamName property
    const teamName = record.team?.name || record.teamName;
    if (!teamName) return null;
    return <Link to={`/teams/${record.teamId}/show`}>{teamName}</Link>;
};

const WarehouseNameField = ({ record }) => {
    if (!record) return null;
    // Handle both nested warehouse object and direct warehouseName property
    const warehouseName = record.warehouse?.name || record.warehouseName;
    if (!warehouseName) return null;
    return (
        <Link to={`/warehouses/${record.warehouseId}/show`}>
            {warehouseName}
        </Link>
    );
};

const OrderIdField = ({ record }) => {
    if (!record || !record.orderId) return null;
    return <Link to={`/orders/${record.orderId}/show`}>{record.orderId}</Link>;
};

const AddressAreaField = ({ record }) => {
    if (!record) return null;
    // Handle both addressArea property and nested address object
    const addressArea = record.addressArea || record.address?.area;
    // Get the address ID from either the nested address object or the direct addressId field
    const addressId = record.address?.id || record.addressId;
    if (!addressArea || !addressId) return null;

    // Return a link to the address detail page
    return <Link to={`/addresses/${addressId}/show`}>{addressArea}</Link>;
};

const RequestList = ({ permissions = [], ...props }) => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    const classes = useStyles();

    // Define default columns configuration
    const defaultColumns: ColumnConfig[] = [
        // Default visible columns (essential information)
        { id: 'serial', label: 'Serial', visible: true, order: 0 },
        { id: 'id', label: 'ID', visible: true, order: 1 },
        { id: 'partner', label: 'Partner', visible: true, order: 2 },
        { id: 'assignee', label: 'Assignee', visible: true, order: 3 },
        { id: 'customer', label: 'Customer', visible: true, order: 4 },
        { id: 'date', label: 'Date', visible: true, order: 5 },
        { id: 'type', label: 'Type', visible: true, order: 6 },
        { id: 'city', label: 'City', visible: true, order: 7 },
        { id: 'area', label: 'Area', visible: true, order: 8 },
        { id: 'status', label: 'Status', visible: true, order: 9 },
        { id: 'show', label: 'Show', visible: true, order: 10 },

        // Optional columns (visible: false by default)
        { id: 'createdAt', label: 'Created At', visible: false, order: 11 },
        { id: 'updatedAt', label: 'Updated At', visible: false, order: 12 },
        { id: 'size', label: 'CBM', visible: false, order: 13 },
        { id: 'actualSize', label: 'Actual CBM', visible: false, order: 14 },
        { id: 'time', label: 'Time', visible: false, order: 15 },
        { id: 'team', label: 'Team', visible: false, order: 16 },
        { id: 'warehouse', label: 'Warehouse', visible: false, order: 17 },
        { id: 'order', label: 'Order', visible: false, order: 18 },
        {
            id: 'chargesStatus',
            label: 'Charges Status',
            visible: false,
            order: 19,
        },
        { id: 'amount', label: 'Amount', visible: false, order: 20 },
        { id: 'currency', label: 'Currency', visible: false, order: 21 },
        { id: 'paymentMode', label: 'Payment Mode', visible: false, order: 22 },
        { id: 'revision', label: 'Revision', visible: false, order: 23 },
        { id: 'isPrimary', label: 'Is Primary', visible: false, order: 24 },
        { id: 'from', label: 'From', visible: false, order: 25 },
        { id: 'to', label: 'To', visible: false, order: 26 },
        { id: 'qty', label: 'Quantity', visible: false, order: 27 },
        {
            id: 'actualQty',
            label: 'Actual Quantity',
            visible: false,
            order: 28,
        },
        { id: 'rating', label: 'Rating', visible: false, order: 29 },
        { id: 'feedback', label: 'Feedback', visible: false, order: 30 },
        { id: 'dispute', label: 'Dispute', visible: false, order: 31 },
        {
            id: 'customerAction',
            label: 'Customer Action',
            visible: false,
            order: 32,
        },
        { id: 'comment', label: 'Comment', visible: false, order: 33 },
        {
            id: 'photosSentAt',
            label: 'Photos Sent At',
            visible: false,
            order: 34,
        },
        { id: 'finishedAt', label: 'Finished At', visible: false, order: 35 },
        {
            id: 'customerAcceptedAt',
            label: 'Customer Accepted At',
            visible: false,
            order: 36,
        },
        {
            id: 'customerComplaint',
            label: 'Customer Complaint',
            visible: false,
            order: 37,
        },
        {
            id: 'hasDynamicFieldsComputed',
            label: 'Has Dynamic Fields',
            visible: false,
            order: 38,
        },
        { id: 'chargeTypes', label: 'Charge Types', visible: false, order: 39 },
        { id: 'country', label: 'Country', visible: false, order: 40 },
        { id: 'userEmail', label: 'User Email', visible: false, order: 41 },
        { id: 'userPhone', label: 'User Phone', visible: false, order: 42 },
        {
            id: 'assigneeEmail',
            label: 'Assignee Email',
            visible: false,
            order: 43,
        },
        {
            id: 'assigneePhone',
            label: 'Assignee Phone',
            visible: false,
            order: 44,
        },
    ];

    // Function to render column based on column ID
    const renderColumn = (columnId: string): ReactNode => {
        switch (columnId) {
            case 'serial':
                return (
                    <TextField
                        key={columnId}
                        source="serial"
                        sortable={false}
                    />
                );
            case 'id':
                return <TextField key={columnId} source="id" />;
            case 'partner':
                return (
                    <FunctionField
                        key={columnId}
                        label="Partner"
                        render={record => {
                            if (!record || !record.partnerId) return null;
                            const partnerName =
                                record.partner?.name || record.partnerName;
                            if (!partnerName) return null;
                            return (
                                <Link to={`/partners/${record.partnerId}/show`}>
                                    {partnerName}
                                </Link>
                            );
                        }}
                    />
                );
            case 'assignee':
                return (
                    <RequestUserField
                        key={columnId}
                        source="assigneeId"
                        label="Assignee"
                    />
                );
            case 'customer':
                return (
                    <RequestUserField
                        key={columnId}
                        source="userId"
                        label="Customer"
                    />
                );
            case 'date':
                return (
                    <DateField key={columnId} locales="en-IN" source="date" />
                );
            case 'type':
                return (
                    <FunctionField
                        key={columnId}
                        label="Type"
                        render={record => {
                            return <Chip label={humanize(record.type)} />;
                        }}
                    />
                );
            case 'size':
                return (
                    <VolumeField
                        key={columnId}
                        source="size"
                        label="CBM"
                        showUnit
                    />
                );
            case 'actualSize':
                return (
                    <VolumeField
                        key={columnId}
                        source="actualSize"
                        label="Actual CBM"
                        showUnit
                    />
                );
            case 'time':
                return <TimeSlotField key={columnId} label="Time" />;
            case 'city':
                return (
                    <FunctionField
                        key={columnId}
                        label="City"
                        render={record => {
                            return <CityNameField record={record} />;
                        }}
                    />
                );
            case 'area':
                return (
                    <FunctionField
                        key={columnId}
                        label="Area"
                        render={record => {
                            return <AddressAreaField record={record} />;
                        }}
                    />
                );
            case 'team':
                return (
                    <FunctionField
                        key={columnId}
                        label="Team"
                        render={record => {
                            return <TeamNameField record={record} />;
                        }}
                    />
                );
            case 'warehouse':
                return (
                    <FunctionField
                        key={columnId}
                        label="Warehouse"
                        render={record => {
                            return <WarehouseNameField record={record} />;
                        }}
                    />
                );
            case 'order':
                return (
                    <OrderReferenceField
                        key={columnId}
                        source="orderId"
                        label="Order"
                    />
                );
            case 'chargesStatus':
                return (
                    <FunctionField
                        key={columnId}
                        label="Charges status"
                        render={record => {
                            const charges = record.charges || [];
                            const isOrderOrStorage =
                                charges.findIndex(
                                    item =>
                                        item.type === 'order' ||
                                        item.type === 'storage'
                                ) !== -1;
                            const isNotOrderOrStorage =
                                charges.findIndex(
                                    item =>
                                        item.type !== 'order' &&
                                        item.type !== 'storage'
                                ) !== -1;

                            if (isOrderOrStorage && isNotOrderOrStorage) {
                                return (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'Center',
                                            justifyContent: 'center',
                                            gap: '.5rem',
                                        }}
                                    >
                                        <img src={storageIcon} />
                                        <img src={otherIcon} />
                                    </div>
                                );
                            } else if (isOrderOrStorage) {
                                return (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'Center',
                                            justifyContent: 'center',
                                            gap: '.5rem',
                                        }}
                                    >
                                        <img src={storageIcon} />
                                    </div>
                                );
                            } else if (isNotOrderOrStorage) {
                                return (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'Center',
                                            justifyContent: 'center',
                                            gap: '.5rem',
                                        }}
                                    >
                                        <img src={otherIcon} />
                                    </div>
                                );
                            } else {
                                return <div></div>;
                            }
                        }}
                    />
                );
            case 'status':
                return (
                    <BoxitChipField
                        key={columnId}
                        record
                        source="status"
                        list="request"
                    />
                );
            case 'show':
                return <ShowButton key={columnId} />;
            case 'createdAt':
                return (
                    <DateField
                        key={columnId}
                        source="createdAt"
                        label="Created At"
                        locales="en-GB"
                    />
                );
            case 'updatedAt':
                return (
                    <DateField
                        key={columnId}
                        source="updatedAt"
                        label="Updated At"
                        locales="en-GB"
                        showTime
                    />
                );
            case 'amount':
                return (
                    <FunctionField
                        key={columnId}
                        label="Amount"
                        render={record => {
                            if (!record.amount) return '-';
                            const currency = record.currency || 'USD';
                            const amount = record.amount / 1000; // Divide by 1000 like other lists
                            return `${currency} ${amount.toLocaleString()}`;
                        }}
                    />
                );
            case 'currency':
                return (
                    <TextField
                        key={columnId}
                        source="currency"
                        label="Currency"
                    />
                );
            case 'paymentMode':
                return (
                    <ChipField
                        key={columnId}
                        source="paymentMode"
                        label="Payment Mode"
                    />
                );
            case 'revision':
                return (
                    <TextField
                        key={columnId}
                        source="revision"
                        label="Revision"
                    />
                );
            case 'isPrimary':
                return (
                    <FunctionField
                        key={columnId}
                        label="Is Primary"
                        render={record => (
                            <Chip
                                label={record.isPrimary ? 'Yes' : 'No'}
                                color={record.isPrimary ? 'primary' : 'default'}
                                size="small"
                            />
                        )}
                    />
                );
            case 'from':
                return <TextField key={columnId} source="from" label="From" />;
            case 'to':
                return <TextField key={columnId} source="to" label="To" />;
            case 'qty':
                return (
                    <TextField key={columnId} source="qty" label="Quantity" />
                );
            case 'actualQty':
                return (
                    <TextField
                        key={columnId}
                        source="actualQty"
                        label="Actual Quantity"
                    />
                );
            case 'rating':
                return (
                    <FunctionField
                        key={columnId}
                        label="Rating"
                        render={record => {
                            if (!record.rating) return '-';
                            return `${record.rating}/5`;
                        }}
                    />
                );
            case 'feedback':
                return (
                    <FunctionField
                        key={columnId}
                        label="Feedback"
                        render={record => (
                            <div
                                style={{
                                    maxWidth: '200px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {record.feedback || '-'}
                            </div>
                        )}
                    />
                );
            case 'dispute':
                return (
                    <FunctionField
                        key={columnId}
                        label="Dispute"
                        render={record => (
                            <Chip
                                label={record.dispute ? 'Yes' : 'No'}
                                color={record.dispute ? 'secondary' : 'default'}
                                size="small"
                            />
                        )}
                    />
                );
            case 'customerAction':
                return (
                    <TextField
                        key={columnId}
                        source="customerAction"
                        label="Customer Action"
                    />
                );
            case 'comment':
                return (
                    <FunctionField
                        key={columnId}
                        label="Comment"
                        render={record => (
                            <div
                                style={{
                                    maxWidth: '200px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {record.comment || '-'}
                            </div>
                        )}
                    />
                );
            case 'photosSentAt':
                return (
                    <DateField
                        key={columnId}
                        source="photosSentAt"
                        label="Photos Sent At"
                        locales="en-GB"
                        showTime
                    />
                );
            case 'finishedAt':
                return (
                    <DateField
                        key={columnId}
                        source="finishedAt"
                        label="Finished At"
                        locales="en-GB"
                        showTime
                    />
                );
            case 'customerAcceptedAt':
                return (
                    <DateField
                        key={columnId}
                        source="customerAcceptedAt"
                        label="Customer Accepted At"
                        locales="en-GB"
                        showTime
                    />
                );
            case 'customerComplaint':
                return (
                    <FunctionField
                        key={columnId}
                        label="Customer Complaint"
                        render={record => (
                            <div
                                style={{
                                    maxWidth: '200px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {record.customerComplaint || '-'}
                            </div>
                        )}
                    />
                );
            case 'hasDynamicFieldsComputed':
                return (
                    <FunctionField
                        key={columnId}
                        label="Has Dynamic Fields"
                        render={record => (
                            <Chip
                                label={
                                    record.hasDynamicFieldsComputed
                                        ? 'Yes'
                                        : 'No'
                                }
                                color={
                                    record.hasDynamicFieldsComputed
                                        ? 'primary'
                                        : 'default'
                                }
                                size="small"
                            />
                        )}
                    />
                );
            case 'chargeTypes':
                return (
                    <FunctionField
                        key={columnId}
                        label="Charge Types"
                        render={record => {
                            if (
                                !record.chargeTypes ||
                                !Array.isArray(record.chargeTypes)
                            )
                                return '-';
                            return record.chargeTypes.join(', ');
                        }}
                    />
                );
            case 'country':
                return (
                    <FunctionField
                        key={columnId}
                        label="Country"
                        render={record => record.country?.name || '-'}
                    />
                );
            case 'userEmail':
                return (
                    <FunctionField
                        key={columnId}
                        label="User Email"
                        render={record => record.user?.email || '-'}
                    />
                );
            case 'userPhone':
                return (
                    <FunctionField
                        key={columnId}
                        label="User Phone"
                        render={record => record.user?.phone || '-'}
                    />
                );
            case 'assigneeEmail':
                return (
                    <FunctionField
                        key={columnId}
                        label="Assignee Email"
                        render={record => record.assignee?.email || '-'}
                    />
                );
            case 'assigneePhone':
                return (
                    <FunctionField
                        key={columnId}
                        label="Assignee Phone"
                        render={record => record.assignee?.phone || '-'}
                    />
                );
            default:
                return null;
        }
    };

    // Ensure we have all required props, but avoid duplicates with what might be in props
    const combinedProps = {
        title: 'Requests',
        permissions,
        defaultColumns,
        storageKey: 'requestListColumns',
        renderColumn,
        bulkActionButtons: false,
        exporter: exporter,
        filtersComponent: <RequestFilter />,
        asideComponent: <FilterSidebar />,
        sort: { field: 'date', order: 'DESC' },
        paginationComponent: <RequestPagination />,
        perPage: 20,
        rowStyle: rowStyle,
        ...props,
        // Ensure these are set if not in props
        resource: props.resource || 'requests',
        location: props.location || { search: '' },
        hasShow: props.hasShow !== undefined ? props.hasShow : true,
    };

    return <CustomizableGrid {...combinedProps} />;
};

RequestList.defaultProps = {
    resource: 'requests',
    location: { search: '' },
};

export default RequestList;
